<div class="bg-light" [class]="sidebar">

    <div class="sidenav navbar fixed-left navbar-expand-xs navbar-light bg-white navbar-vertical" (mouseover)="show()"
      (mouseout)="hide()">
      <div class="scroll-wrapper scrollbar-inner">
        <div class="scrollbar-inner scroll-content scroll-scrolly_visible"
          [ngClass]="{'scroll-scrollx_visible': isCollapsed}">
          <div class="sidenav-header  d-flex  align-items-center">
            <a class="navbar-brand" [routerLink]="['/school']">
              <img src="/assets/img/brand/logo_nvs.jpg" class="navbar-brand-img" alt="...">
            </a>
            <div class="ml-auto">
              <!-- Sidenav toggler -->
              <div class="sidenav-toggler d-none d-xl-block" [ngClass]="{'active': !isCollapsed}" (click)="collapsed()">
                <div class="sidenav-toggler-inner">
                  <i class="sidenav-toggler-line"></i>
                  <i class="sidenav-toggler-line"></i>
                  <i class="sidenav-toggler-line"></i>
                </div>
              </div>
              <button type="button" class="close d-xl-none mr-2" (click)="collapsed()">
                <i class="material-icons md-24">close</i>
              </button>
            </div>
          </div>
          <div class="navbar-inner">
            <app-sidebar></app-sidebar>
          </div>
        </div>
      </div>
    </div>
    <div class="main-content min-vh-100">
      <app-header (collapsed)="collapsed()" (search)="showSearch()" (close)="closeSearch()"></app-header>
  
      <router-outlet></router-outlet>
    </div>
  
  </div>